import React from 'react';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { faCircleExclamation } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { DialogClose, DialogFooter } from '@/components/ui/dialog';
import { Form as ShadcnForm } from '@/components/ui/form';
import { Alert } from '../../../../../../shared/components/Alert';
import { InputField, SubmitButton } from '../../../../../../shared/components/Form';
import { formShape } from '../../../../../shared/types';
import { ERROR_TITLES } from '../../../constants';
import { useDialogs } from '../../../hooks';

const Form = ({ errorMessage, form, isSubmitting, onSubmit }) => {
  const { activeStatus } = useDialogs();

  const alertTitle = activeStatus
    ? ERROR_TITLES.status.update
    : ERROR_TITLES.status.create;

  return (
    <ShadcnForm {...form}>
      <form className="flex flex-col gap-4" onSubmit={form.handleSubmit(onSubmit)}>
        <InputField
          control={form.control}
          name="name"
          placeholder="Status name"
          variant="ghost"
        />

        {!isEmpty(errorMessage) && (
          <Alert
            description={errorMessage}
            icon={<FontAwesomeIcon icon={faCircleExclamation} />}
            title={alertTitle}
            variant="destructive"
          />
        )}

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>

          <SubmitButton isLoading={isSubmitting}>Save</SubmitButton>
        </DialogFooter>
      </form>
    </ShadcnForm>
  );
};

Form.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  form: formShape.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Form;
